export default __webpack_public_path__ + "static/media/Poppins-Medium.4cbed326.woff";